'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';
import Socials from '~/components/socials';
import SocialContact from '~/data/strapi/types/single-types/common-data/social-contact';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import emailHref from '~/utils/email-href';
import phoneHref from '~/utils/phone-href';

import styles from './styles.module.css';

interface Props {
  phone: string | null;
  email: string | null;
  socialContacts: SocialContact[] | null;
}

const FormContacts: FC<Props> = ({ phone, email, socialContacts }) => {
  const contactsCount = socialContacts?.length || 0;
  const { captureGoal } = useMetrika();

  const onPhoneClick = () => {
    captureGoal(YMGoal.NUMBER_CLICK);
  };

  const onEmailClick = () => {
    captureGoal(YMGoal.EMAIL_CLICK);
  };

  return (
    <div className={styles.bottomContainer}>
      <div className={styles.contactsContainer}>
        {phone && (
          <Link onClick={onPhoneClick} href={phoneHref(phone)} className={styles.contact}>
            <Icon name="phone" className={styles.icon} />
            {phone}
          </Link>
        )}
        {email && (
          <Link onClick={onEmailClick} href={emailHref(email)} className={styles.contact}>
            <Icon name="email" className={styles.icon} />
            {email}
          </Link>
        )}
      </div>
      {socialContacts && (
        <Socials
          data={socialContacts}
          iconClassName={styles.social}
          containerClassName={clsx(styles.socialContainer, contactsCount === 1 && styles.absolute)}
        />
      )}
    </div>
  );
};

export default FormContacts;
